import { Component, OnInit, OnDestroy } from '@angular/core';
import { LocationService } from '../../locations/services/location.service';
import { NavigationStart, Router, Params, ActivatedRoute } from '@angular/router';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { DashboardService } from '../services/dashboard.service';
import * as moment from 'moment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  public pageParams: any = {
    startDate: new Date(Date.now() - 604800000), // Last week
    endDate: new Date()
  };
  public selectOptions: any[];
  public locations: any[] = [];
  public loading: boolean;
  private filterFields: string[] = ['locationId', 'startDate', 'endDate', 'offerSortBy', 'retention'];
  public token: any;
  public topUsers: any[] = [
    {
      name: 'user1',
      workplace: 'workplace1',
      redemptions: 11,
    },
    {
      name: 'user2',
      workplace: 'workplace2',
      redemptions: 12,
    },
    {
      name: 'user3',
      workplace: 'workplace3',
      redemptions: 13,
    },
  ];
  public topOffers: any[] = [
    {
      name: 'offer1',
      workplace: 'workplace1',
      redemptions: 11,
    },
    {
      name: 'offer2',
      workplace: 'workplace2',
      redemptions: 12,
    },
    {
      name: 'offer3',
      workplace: 'workplace3',
      redemptions: 13,
    },
  ];
  public globalStats: any = {};
  public memberStats: any = {};
  public conversionStats: any = {};
  public retentionStats: any = {};

  public topOffersLoading: boolean;
  public topUsersLoading: boolean;
  public statsLoading: boolean;
  public memberStatsLoading: boolean;
  public conversionStatsLoading: boolean;
  public retentionStatsLoading: boolean;
  private prevPageParams: any;

  constructor(
    private locationService: LocationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routeHelperService: RouteHelperService,
    private dashboardService: DashboardService,
    private titleService: Title,
  ) {
    // this.token = this.authDataStorageService.getSessionTokenFromStorage();
    // this.selectOptions = this.memberService.getMemberStatuses();
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.prevPageParams = this.pageParams;
      }
    });
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        const tparams = { ...params };
        tparams.startDate = tparams.startDate || '';
        tparams.endDate = tparams.endDate || '';
        this.pageParams = tparams;

        // TODO: Temporary disabled
        this.loadTopOffers(this.pageParams);
        this.loadTopUsers(this.pageParams);
        // this.loadStats(this.pageParams);
        this.loadRetentionStats(this.pageParams);
        // this.loadStatusStats(this.pageParams);
        // this.loadConversionStats(this.pageParams);
      });

    this.locationService.getLocationData().then((resp: any[]) => {
      resp.unshift({
        id: '',
        value: 'All Locations',
      });
      this.locations = resp;
    });
    this.titleService.setTitle(`Dashboard | CODE Hospitality CMS`);
  }

  ngOnDestroy(): void {
      this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private loadStats(data: any) {
    if (!this.filtersChanged(data)) {
      return;
    }
    this.statsLoading = true;
    this.dashboardService.getStats(this.pageParams).subscribe(resp => {
      const jsonResp = resp.json();
      this.globalStats = jsonResp;
      this.statsLoading = false;
    });
  }

  private loadStatusStats(data: any) {
    if (!this.filtersChanged(data)) {
      return;
    }
    this.memberStatsLoading = true;
    this.dashboardService.getStatusStats(this.pageParams).subscribe(resp => {
      const jsonResp = resp.json();
      this.memberStats = jsonResp;
      this.memberStatsLoading = false;
    });
  }

  private loadConversionStats(data: any) {
    if (!this.filtersChanged(data)) {
      return;
    }
    this.conversionStatsLoading = true;
    this.dashboardService.getConversionStats(this.pageParams).subscribe(resp => {
      const jsonResp = resp.json();
      this.conversionStats = jsonResp;
      this.conversionStatsLoading = false;
    });
  }

  private loadRetentionStats(data: any) {
    if (!this.filtersChanged(data)) {
      return;
    }
    this.retentionStatsLoading = true;
    this.dashboardService.getRetentionStats(this.pageParams).subscribe(resp => {
      const jsonResp = resp.json();
      this.retentionStats = jsonResp;
      this.retentionStatsLoading = false;
    });
  }

  private loadTopOffers(data: any) {
    if (this.prevPageParams) {
      if (!this.filtersChanged(data) && (data && this.prevPageParams && data.offerSortBy === this.prevPageParams.offerSortBy)) {
        return;
      }
    }

    const params: any = { ...data };
    delete params.offerSortBy;
    if ('WORST' === data.offerSortBy) {
      params.sortBy = 'REDEMPTIONS_COUNT';
      params.sortOrder = 'ASC';
    } else if ('EXPIRY' === data.offerSortBy) {
      params.sortBy = 'END_DATE';
      params.sortOrder = 'ASC';
    } else {
      params.sortBy = 'REDEMPTIONS_COUNT';
      params.sortOrder = 'DESC';
    }
    this.topOffersLoading = true;
    this.dashboardService.getTopOffers(params).subscribe(resp => {
      const jsonResp = resp.json();
      this.topOffers = jsonResp.items;
      this.topOffersLoading = false;
    });
  }

  private loadTopUsers(data: any) {
    if (!this.filtersChanged(data)) {
      return;
    }

    this.topUsersLoading = true;
    const topUsersParams = {
      startDate: data.startDate,
      endDate: data.endDate,
      locationId: data.locationId,
      numberOfResults: 10
    };

    this.dashboardService.getTopUsers(topUsersParams).subscribe(resp => {
      this.topUsers = resp.json();
      this.topUsersLoading = false;
    });
  }

  private filtersChanged(data: any): boolean {
    return !(data &&
      this.prevPageParams &&
      data.locationId === this.prevPageParams.locationId &&
      data.startDate === this.prevPageParams.startDate &&
      data.endDate === this.prevPageParams.endDate);
  }

  public changeOfferSort(type: string) {
    const params = { ...this.pageParams };
    params.offerSortBy = type;

    this.router.navigate([], { queryParams: params });
  }

  public changeRetentionFilter(type: string) {
    const params = { ...this.pageParams };
    params.retention = type;

    this.router.navigate([], { queryParams: params });
  }

  public filterMembersWithStatus(status: string) {
    this.router.navigate(['/admin/members'], {
      queryParams: {
        type: status,
      },
    });

    return false;
  }

  public clearFilters() {
    this.filterSearch({}, ['locationId', 'startDate', 'endDate']);
  }

  public locationChanged(event) {
    if ('string' !== typeof event) {
      return;
    }

    this.filterSearch({
      locationId: event,
    });
  }

  public datepickerChanged(value) {
    const startDateAsString = moment(value.start._d).format('YYYY-MM-DD');
    const endDateAsString = moment(value.end._d).format('YYYY-MM-DD');

    this.filterSearch({
      startDate: startDateAsString,
      endDate: endDateAsString,
    });
  }

  private filterSearch(data, except = []) {
    const result = {};
    this.filterFields.forEach(index => result[index] = data[index] !== null ? data[index] : this.pageParams[index]);
    except.forEach(index => delete result[index]);
    this.router.navigate([], { queryParams: result });
  }

  get isTopOfferSort() {
    return !this.pageParams.offerSortBy || 'TOP' === this.pageParams.offerSortBy;
  }

  get isWorstOfferSort() {
    return 'WORST' === this.pageParams.offerSortBy;
  }

  get isExpiryOfferSort() {
    return 'EXPIRY' === this.pageParams.offerSortBy;
  }

  public getRetentionStatLabel(stat: string) {
    const statData = this.currentRetentionStats[stat];
    if (!statData) {
      return 'N/A';
    }

    return statData.toFixed(2) + '%';
  }

  public getConversionLabel(stat: string) {
    const statData = this.conversionStats[stat];
    if (!statData) {
      return 'N/A';
    }

    return statData.toFixed(2) + '%';
  }

  get currentRetentionStats() {
    if (!this.retentionStats) {
      return {};
    }

    return this.isActiveRetention ? this.retentionStats.activeUsers || {} : this.retentionStats.liveUsers || {};
  }

  get isLiveRetention() {
    return 'LIVE' === this.pageParams.retention;
  }

  get isActiveRetention() {
    return !this.pageParams.retention || 'ACTIVE' === this.pageParams.retention;
  }

  public statClick() {
    return false;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/dashboard/dashboard/dashboard.component.ts